// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".bracket-match-module__teamWrapper--22bhQ{height:45px;padding:0 10px;position:relative;color:#fefefe}.bracket-match-module__matchWrapper--30udW{width:194px;border-radius:6px;background-color:#1a1b20;border:1px solid #393a40}.bracket-match-module__matchWrapper--30udW .bracket-match-module__teamWrapper--22bhQ:first-child{border-bottom:1px solid #393a40;box-sizing:content-box}", ""]);
// Exports
exports.locals = {
	"teamWrapper": "bracket-match-module__teamWrapper--22bhQ",
	"matchWrapper": "bracket-match-module__matchWrapper--30udW"
};
module.exports = exports;
